/**
 * Single source for WordPress.com OAuth config. All values come from env vars:
 * - Local: use .env.local (REACT_APP_WORDPRESS_CLIENT_ID, REACT_APP_WORDPRESS_CLIENT_SECRET, REACT_APP_WORDPRESS_REDIRECT_URI)
 * - Production: set same vars in Amplify (or your host) environment
 */
const getEnv = (key: string): string => {
  const value = process.env[key];
  return typeof value === "string" ? value : "";
};

export const getWordPressClientId = (): string =>
  getEnv("REACT_APP_WORDPRESS_CLIENT_ID");

export const getWordPressRedirectUri = (): string => {
  const fromEnv = getEnv("REACT_APP_WORDPRESS_REDIRECT_URI").trim();
  if (fromEnv) return fromEnv;
  return `${window.location.origin}/connect/wordpress/callback`;
};
